var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0f212e",
    d: "M209,440.73V371.07H0V270.17L158.19,6.51H340.47v250H390.6V371.07H340.47v69.66Zm0-321L127,256.49h82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0f212e",
    d: "M414,223.94C414,106.11,477.17,0,606.72,0s192.7,106.11,192.7,223.94-63.15,224.6-192.7,224.6S414,341.78,414,223.94Zm253.24,0c0-73.56-18.88-108.06-60.55-108.06s-60.54,34.5-60.54,108.06,18.88,108.72,60.54,108.72S667.27,297.51,667.27,223.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0f212e",
    d: "M1031.82,440.73V371.07h-209V270.17L981,6.51h182.28v250h50.13V371.07h-50.13v69.66Zm0-321-82,136.71h82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4012ae3e189a7462da9001ce0a91dc01.svg";
export { ForwardRef as ReactComponent };